import { Injectable, signal } from '@angular/core';
import { HttpWaitService } from '@abp/ng.core';
import { Subscription, of, timer } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { HealthCheckService } from 'src/app/proxy/health-checks';
import { LocalStorageConsts } from '../AppConsts';

@Injectable({ providedIn: 'root' })
export class ConnectionService {
  readonly online = signal(false);

  private monitoringSubscription?: Subscription;

  constructor(
    private readonly httpWaitService: HttpWaitService,
    private readonly healthCheckService: HealthCheckService,
  ) {
    this.httpWaitService.addFilter({
      method: 'GET',
      endpoint: '/api/app/health-check/check-health',
    });
    this.startMonitoring();
  }

  startMonitoring(): void {
    if (this.monitoringSubscription) {
      return;
    }

    this.monitoringSubscription = timer(0, LocalStorageConsts.HealthCheckInterval)
      .pipe(
        switchMap(() =>
          this.healthCheckService
            .checkHealth({
              skipHandleError: true,
            })
            .pipe(catchError(() => of(false)))
        )
      )
      .subscribe(isOnline => {
        this.online.set(isOnline);
      });
  }
}
